import { render } from "./TheNavigation.vue?vue&type=template&id=be986850&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=be986850&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be986850"

export default script